/** Auth UI gate — set REACT_APP_ADMIN_EMAILS on Vercel in production. Fails closed when unset. */

function parseAdminEmails(raw) {
  const source = raw?.trim();
  if (!source) return [];
  return source
    .split(',')
    .map((e) => e.trim().toLowerCase())
    .filter(Boolean);
}

export function isAdminEmail(email) {
  if (!email) return false;
  return parseAdminEmails(process.env.REACT_APP_ADMIN_EMAILS).includes(email.toLowerCase());
}

export function getAdminEmails() {
  return parseAdminEmails(process.env.REACT_APP_ADMIN_EMAILS);
}
